import React from 'react';

// Shared Enter/Space activation for the selectable card panels (SelectableRadioCard,
// SelectableCheckboxCard). Only activates when the card itself is focused — key events bubbling up
// from interactive descendants (the radio/checkbox, search inputs, chip buttons) keep their native
// keyboard behavior. A disabled card never activates.
export function handleSelectableCardKeyDown(
  event: React.KeyboardEvent<HTMLDivElement>,
  onActivate: () => void,
  disabled = false
): void {
  if (disabled) {
    return;
  }
  if (event.target !== event.currentTarget) {
    return;
  }
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onActivate();
  }
}
